/** Shared i18n key prefix for the maintenance-data filter area. */
export const FILTER_MSG = 'intl-msg:vehicle-diagnostics.maintenance.filter';
